import React, { useEffect, useRef, useState } from 'react';

import Header from '../../../../components/Header/Header';

const TITLE_MAX_LENGTH = 100;
const TITLE_PLACEHOLDER = 'E.g. Need help reviewing my pitch deck';

const block = 'create-service-request';

export interface ServiceRequestTitleEditorProps {
  initialTitle: string;
  onDone: (title: string) => void;
  onClose: () => void;
}

const ServiceRequestTitleEditor: React.FC<ServiceRequestTitleEditorProps> = ({
  initialTitle,
  onDone,
  onClose,
}) => {
  const [title, setTitle] = useState(initialTitle);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    const len = el.value.length;
    const id = requestAnimationFrame(() => {
      el.setSelectionRange(len, len);
    });
    return () => cancelAnimationFrame(id);
  }, [initialTitle]);

  const isDoneActive = title.trim().length > 0;

  const handleDone = () => {
    onDone(title);
  };

  return (
    <div className={`${block} ${block}--editor page__container`}>
      <Header
        title="Service Request Title"
        handleBack={onClose}
        backType="cross"
        actionItems={[
          <button
            key="done"
            type="button"
            className={`${block}__header-done ${
              isDoneActive ? `${block}__header-done--active` : ''
            }`}
            disabled={!isDoneActive}
            onClick={handleDone}>
            Done
          </button>,
        ]}
      />
      <div className={`${block}__editor-content`}>
        <input
          ref={inputRef}
          type="text"
          className={`${block}__editor-input`}
          placeholder={TITLE_PLACEHOLDER}
          value={title}
          onChange={(e) =>
            setTitle(e.target.value.slice(0, TITLE_MAX_LENGTH))
          }
          maxLength={TITLE_MAX_LENGTH}
          autoFocus
        />
        <div
          className={`${block}__char-count ${
            title.length > 0 ? `${block}__char-count--active` : ''
          }`}>
          {title.length}/{TITLE_MAX_LENGTH}
        </div>
      </div>
      <div className={`${block}__editor-keyboard-spacer`} />
    </div>
  );
};

export default ServiceRequestTitleEditor;
